const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const isValidEmail = {
  errorMessage: 'ERROR_IS_VALID_EMAIL',
  rule: (email: any) => emailRegex.test(String(email).toLowerCase()),
};

export default isValidEmail;
